// @ts-nocheck
import { useGet, usePost, usePut, useDelete } from "./useRequest";

export const loadDocumentCategoriesByOrg = (organisationId) => {
  const path = `/documentcategory/${organisationId}/all`;
  const response = useGet(path);
  return response;
};

export const getDocumentCategory = (categoryId) => {
    const path = `/documentcategory/${categoryId}`;
    const response = useGet(path);
    return response;
};

export const createDocumentCategory = (documentCategory) => {
    const path = `/documentcategory`;
    const data = documentCategory;
    if (!path) {
        throw new Error("Path is required");
    }
    const response = usePost(path, data);
    return response;
  };

  export const updateDocumentCategory = (docCategoryId, documentCategory) => {
    const path = `/documentcategory/${docCategoryId}/update`;
    if (!path) {
        throw new Error("Path is required");
    }
    const response = usePut(path, documentCategory);
    return response;
  };

  export const deleteDocumentCategory = (docCategoryId) => {
    const path = `/documentcategory/${docCategoryId}/delete`;

    if (!path) {
      throw new Error("Path is required");
    }
    const response = useDelete(path);
    return response;
  };